<template>
  <div :id="chartId" class="chartheight" :style="{ width: '100%' }"></div>
</template>

<script>
const colorArr = [
  "#4878FF",
  "#4CDFC0",
  "#F3F3F3",
  "#FFB95E",
  "#5882FB",
  "#49C568",
  "#AEB3F1",
  "#CCCCCC",
];
export default {
  props: {
    seriesData: {
      type: Array,
      default: () => [],
    },
    chartId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        // {
        //   name: "高级白领",
        //   count: 12,
        //   rate: "0.00%",
        // },
        // {
        //   name: "小白领",
        //   count: 2,
        //   rate: "0.00%",
        // },
        // {
        //   name: "土豪",
        //   count: 3,
        //   rate: "0.00%",
        // },
        // {
        //   name: "收入很少",
        //   count: 5,
        //   rate: "0.00%",
        // },
        // {
        //   name: "蓝领",
        //   count: 10,
        //   rate: "0.00%",
        // },
        // {
        //   name: "未识别",
        //   count: 11,
        //   rate: "0.00%",
        // },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chartData = this.seriesData;
      if (this.chartData.length > 0) {
        this.drawOrderCareBar();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      }
    });
  },
  methods: {
    //绘制柱状图
    drawOrderCareBar() {
      let orderCareBarChart = this.$echarts.init(
        document.getElementById(this.chartId),
        "light"
      ); //初始化echats实例
      orderCareBarChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} 人",
        },
        grid: {
          left: "62",
        },
        color: ["#7e86ec"],
        xAxis: {
          type: "category",
          data: this.chartData.map((v) => v.name),
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#666666",
            },
          },
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          {
            type: "bar",
            barWidth: 20, //柱图宽度
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  // show: true, //开启显示
                  // position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#666666",
                    fontSize: 14,
                  },
                },
              },
            },
            data: this.chartData.map((v) => v.count),
          },
        ],
      });
      window.onresize = function () {
        orderCareBarChart.resize();
      };
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight {
  height: 310px !important;
  @media screen and (max-width: 1400px) {
    margin-top: -20px;
    height: 280px !important;
  }
  @media screen and (max-width: 1340px) {
    margin-top: -10px;
    height: 230px !important;
  }
}
// .order_money {
//   height: 100%;
//   background: rgba(255, 255, 255, 1);
//   box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
//   border-radius: 6px;
//   overflow: hidden;
//   .head {
//     box-sizing: border-box;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     height: 54px;
//     padding: 0 24px;
//     span {
//       color: #2e3458;
//       font-size: 16px;
//       font-weight: 800;
//     }
//     img {
//       width: 18px;
//       height: 18px;
//       cursor: pointer;
//     }
//     border-bottom: 1px solid #f6f6f6;
//   }
//   .content {
//     height: 306px;
//   }
// }
</style>
